<template>
  <div class="shippers-used color33">
    <!-- <shippersHead @shippers-empty="empty"></shippersHead> -->
    <div class="shippers-used_tip colorB" v-if="!shippersData.length">
      提示： 一般正常情况下，系统可以自动检测物流商、发件国及目的地国家。无需进行手动指定操作。但由于物流跟踪已实现合并全球邮政、国际快递及电商物流专线统一查询，系统极其复杂，可能因为物流商单号规则冲突、新物流商暂无支持、官网未录入目的地国家等问题。因此，我们不能100%正确识别。这里您将可以手动指定包裹运输商，获取完整的跟踪信息。感谢您的理解，如果对本系统有好的建议，非常欢迎您联系我们。
    </div>
    <div class="shippers-used_history" v-if="shippersData.length">
      <div class="shippers-used_history-text colorB">搜索历史</div>
      <div class="shippers-used_history-box">
        <shippers-box
          v-for="(item, index) in shippersData"
          v-show="item.isSupported"
          :key="index"
          :shippers-data="item"
          @shippers-close="close">
        </shippers-box>
      </div>
    </div>
  </div>
</template>

<script>
// import shippersHead from 'components/shippers/shippersHead.vue'
import shippersBox from './shippersBox'
export default {
  data () {
    return {

    }
  },
  props: {
    shippersData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    // shippersHead,
    shippersBox
  },
  mounted () {

  },
  methods: {
    close () {
      this.$emit('shippers-close')
    },
    empty () {
      this.$emit('shippers-empty')
    }
  }
}
</script>

<style scoped>
  .shippers-used_history {
    width: 100%;
  }
  .shippers-used_history-text {
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  .shippers-used_history-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    max-height: 270px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/shippers/shippersUsed.vue